export default __webpack_public_path__ + "static/media/ethically-sourced-000000.0671479d.png";